import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import NotificationMemberAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/notification-member.entity';

@Component({
  selector: 'app-notifications-filters',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatOptionModule,
    MatInputModule,
    MatIconModule,
    MatFormFieldModule,
    FormsModule
  ],
  templateUrl: './notifications-filters.component.html',
})
export class NotificationsFiltersComponent implements OnChanges{
  @Input() form!: FormGroup;
  @Input() notificationGroupList: any[] = [];
  @Input() notificationMemberList: NotificationMemberAttributes[] = [];

  @Input() useSelects: ('notificationGroup' | 'notificationMember')[] = ['notificationGroup', 'notificationMember'];

  searchNotificationGroup = '';
  searchNotificationMember = '';

  filteredNotificationGroupList: any[] = [];
  filterednotificationMemberList: NotificationMemberAttributes[] = [];

  ngOnInit(): void {
    this.filteredNotificationGroupList = [...this.notificationGroupList];
    this.filterednotificationMemberList = [...this.notificationMemberList];
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes['notificationGroupList']) {
      this.filteredNotificationGroupList = [...this.notificationGroupList];
    }

    if (changes['notificationMemberList']) {
      this.filterednotificationMemberList = [...this.notificationMemberList];
    }


    this.filterNotificationGroup(this.searchNotificationGroup);
    this.filterNotificationMmeber(this.searchNotificationMember);

  }

  filterNotificationGroup(search: string): void {
    const value = search?.toLowerCase() ?? '';

    if (value === '') {
      this.filteredNotificationGroupList = this.notificationGroupList;
    } else {
      this.filteredNotificationGroupList = this.notificationGroupList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  filterNotificationMmeber(search: string): void {
    const value = search?.toLowerCase() ?? '';

    if (value === '') {
      this.filterednotificationMemberList = this.notificationMemberList;
    } else {
      this.filterednotificationMemberList = this.notificationMemberList.filter(item =>
        item.name?.toLowerCase().includes(value)
      );
    }
  }

  getDisplayValue(list: any[], selected: any, field: string): string {
    if (!selected || list.length === 0) return '';
    const values = Array.isArray(selected) ? selected : [selected];
    return list
      .filter(item => values.includes(item._id) || values.includes(item.id) || values.includes(item.code))
      .map(item => item[field])
      .join(', ');
  }
}
